import React from 'react';
import { X, Check } from 'lucide-react';
const rows = [{
  bad: 'Hours planning from scratch every week',
  good: '5 minutes. Everything ready.'
}, {
  bad: 'Improvised sessions with no real progression',
  good: '365 days of sessions by age group'
}, {
  bad: 'Groups with no system or continuity',
  good: 'A clear structure week after week'
}, {
  bad: 'Improvised preseason',
  good: 'Structured blocks with no injuries'
}, {
  bad: 'No set plays when the match is tight',
  good: 'Pro set pieces to unlock any match'
}, {
  bad: 'Arriving at the field anxious',
  good: 'Arriving with total clarity'
}];
export function Comparison() {
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-37" data-mp="28x8fbq3xf84k">
      <div className="max-w-4xl mx-auto" data-id="element-38" data-mp="28um8xtsruynx">
        <h2 className="font-display uppercase text-center text-gray-900 text-[7vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-9 md:mb-12" data-id="element-39" data-mp="9knvb71lxdd6">
          What does <span className="text-neon-deep" data-id="element-40" data-mp="eks9gqf1lw08">not</span> having it cost
          you?
        </h2>

        <div className="border border-gray-200" data-id="element-41" data-mp="1m2jzdvzpbjm9">
          <div className="grid grid-cols-2" data-id="element-42" data-mp="1h8xtqnrygfzy">
            <div className="bg-gray-50 px-3 py-4 md:px-5 md:py-5 text-center border-b border-r border-gray-200" data-id="element-43" data-mp="1h85y5cycyi9o">
              <span className="font-display uppercase text-gray-500 text-sm md:text-xl" data-id="element-44" data-mp="189auo8mp7ma2">
                Without Rugby 360
              </span>
            </div>
            <div className="bg-ink px-3 py-4 md:px-5 md:py-5 text-center border-b border-gray-200" data-id="element-45" data-mp="24z1p67uzp9fv">
              <span className="font-display uppercase text-acid text-sm md:text-xl" data-id="element-46" data-mp="20yrh8pnn08yd">
                With Rugby 360
              </span>
            </div>
          </div>

          {rows.map(row => <div key={row.bad} className="grid grid-cols-2" data-id="element-47" data-mp="1qzk6894dkqef">
              <div className="flex items-start gap-2 md:gap-3 px-3 py-4 md:px-5 md:py-6 border-t border-r border-gray-200 text-gray-600 text-[0.8rem] md:text-base" data-id="element-48" data-mp="kjzxt28gyc17">
                <X className="text-red-400 flex-shrink-0 mt-0.5" size={16} aria-hidden="true" data-id="element-49" data-mp="h1spzwhcr1ha" />
                <span data-id="element-50" data-mp="m041scr7jm25">{row.bad}</span>
              </div>
              <div className="flex items-start gap-2 md:gap-3 px-3 py-4 md:px-5 md:py-6 border-t border-gray-200 text-gray-900 font-medium bg-neon/[0.07] text-[0.8rem] md:text-base" data-id="element-51" data-mp="81nmvyj6yp8x">
                <Check className="text-neon-deep flex-shrink-0 mt-0.5" size={16} aria-hidden="true" data-id="element-52" data-mp="3ugysktuqdfzv" />
                <span data-id="element-53" data-mp="3446ot2xo2ec">{row.good}</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}